module.exports = __webpack_public_path__ + "media/images/icon/four_player_scramble-f0cb4b521f1df4ff58682cf157297c5a.png";